// @ts-check
/**
 * Small pure helpers for the admin Showcase screen.
 *
 * The enum values below mirror /shared/api-constants.js (SHOWCASE_*). The admin build cannot import
 * that file (Create React App refuses imports from outside src), so utils/showcase.test.js compares
 * these copies to the shared file and fails if they drift.
 */

export const SHOWCASE_KIND = Object.freeze({
  UGC: 'ugc',
  SPOTTED: 'spotted',
});

export const SHOWCASE_STATUS = Object.freeze({
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
});

export const SHOWCASE_MEDIA_TYPE = Object.freeze({
  VIDEO: 'video',
  IMAGE: 'image',
});

/**
 * Status chip text for the server's hidden_reason (null means the item is live).
 * @param {string | null | undefined} reason
 */
export function hiddenReasonLabel(reason) {
  switch (reason) {
    case 'permission_missing':
      return 'Hidden: permission not confirmed';
    case 'product_unavailable':
      return 'Hidden: product unavailable';
    case 'not_published':
      return 'Draft';
    default:
      return 'Live';
  }
}

/**
 * Mirrors the backend publish rules (services/showcase.publish_errors) for instant inline feedback.
 * The backend stays authoritative.
 * @param {Record<string, any>} form
 * @param {{ alreadyPublished?: boolean }} [options] alreadyPublished: the item is live before this
 *   edit, so unticking permission is allowed (it stays published but hidden).
 * @returns {string[]}
 */
export function canPublish(form, { alreadyPublished = false } = {}) {
  const errors = [];
  if (!form.product_id) errors.push('A linked product is required.');
  if (!(form.media_url || '').trim()) errors.push('Media is required.');
  if (!alreadyPublished && !form.permission_confirmed)
    errors.push('Permission to feature this content must be confirmed.');
  if (form.media_type === SHOWCASE_MEDIA_TYPE.VIDEO && !(form.poster_url || '').trim()) {
    errors.push('Videos need a poster image.');
  }
  if (form.kind === SHOWCASE_KIND.SPOTTED && !(form.person_name || '').trim()) {
    errors.push("Spotted items need the person's name.");
  }
  return errors;
}
